var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContentsVisibilityDisabledIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50006 4.18184C7.22119 4.18184 6.18188 5.22115 6.18188 6.50002C6.18188 7.7789 7.22119 8.81821 8.50006 8.81821C9.77893 8.81821 10.8182 7.7789 10.8182 6.50002C10.8182 5.22115 9.7789 4.18184 8.50006 4.18184Z",
    fill: "#D7DBE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50002 0.704567C4.63637 0.704567 1.33683 3.10773 0 6.50003C1.33683 9.89229 4.63637 12.2955 8.50002 12.2955C12.3675 12.2955 15.6632 9.89229 17 6.50003C15.6632 3.10773 12.3675 0.704567 8.50002 0.704567ZM8.50002 10.3636C6.36729 10.3636 4.63637 8.63272 4.63637 6.49999C4.63637 4.36726 6.36729 2.63637 8.50002 2.63637C10.6327 2.63637 12.3637 4.3673 12.3637 6.50003C12.3637 8.63275 10.6327 10.3636 8.50002 10.3636Z",
    fill: "#D7DBE4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentsVisibilityDisabledIcon);
export default __webpack_public_path__ + "static/media/contents-visibility-disabled-icon.d929a3e2.svg";
export { ForwardRef as ReactComponent };